module.exports = __webpack_public_path__ + "img/logo-pixel.96c2ab63.gif";